<template>
    <v-app>
        <v-content class="print-p-0">
            <v-snackbar class="hide-on-print"
                :color="snackbar.color"
                :timeout="snackbar.timeout"
                bottom
                right
                v-model="snackbar.show"
            >
                {{ snackbar.text }}
                <v-btn @click.native="snackbar.show = false" dark text icon>
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
<!--          <v-snackbar bottom right :value="updateExists" :timeout="0" color="primary">-->
<!--            An update is available.Please click refresh-->
<!--            <v-btn text @click="refreshApp">-->
<!--              Refresh-->
<!--            </v-btn>-->
<!--          </v-snackbar>-->
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
    import colors from 'vuetify/es5/util/colors';
    import {updatePWAMixin} from "./mixins/updatePWAMixin";
    export default {
        name: "App",
        data() {
            return {
                rightDrawer: false,
                colors: colors
            };
        },
      mixins:[updatePWAMixin],
        methods: {
            openThemeSettings() {
                this.$vuetify.goTo(0);
                this.rightDrawer = (!this.rightDrawer);
            },
        },
        computed: {
            snackbar() {
                return this.$store.state.Notification.snackbar;
            }
        }

    };
</script>
